/**
 * Labstep
 *
 * @module services/redux-state
 * @description Service for business logic related to Redux state management
 */

import sortBy from 'lodash/sortBy';

export class ReduxStateService {
  public static stringifyParamsInOrder(object: Record<string, any>) {
    if (!object || typeof object !== 'object') {
      return JSON.stringify({});
    }
    return JSON.stringify(ReduxStateService.orderObjectByKey(object));
  }

  public static orderObjectByKey<T extends Record<string, any>>(
    object: T,
  ): T {
    if (!object || typeof object !== 'object') {
      return {} as T;
    }

    const sortedKeys = sortBy(Object.keys(object));
    const result = {} as T;

    for (const key of sortedKeys) {
      result[key as keyof T] = object[key];
    }

    return result;
  }
}
